import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 32,
			rx: 4,
			fill: "#76ec71"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_828_12962)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20 6.25C18.0716 6.25 16.1866 6.82183 14.5832 7.89317C12.9798 8.96451 11.7301 10.4873 10.9922 12.2688C10.2542 14.0504 10.0611 16.0108 10.4373 17.9021C10.8136 19.7934 11.7422 21.5307 13.1057 22.8943C14.4693 24.2579 16.2066 25.1865 18.0979 25.5627C19.9892 25.9389 21.9496 25.7458 23.7312 25.0078C25.5127 24.2699 27.0355 23.0202 28.1068 21.4168C29.1782 19.8134 29.75 17.9284 29.75 16C29.745 13.4157 28.7162 10.9386 26.8888 9.11118C25.0614 7.28378 22.5843 6.25496 20 6.25ZM24.6406 14.2938L19.1469 19.5438C19.0048 19.6774 18.8169 19.7512 18.6219 19.75C18.5266 19.7514 18.4319 19.7338 18.3434 19.6984C18.2549 19.663 18.1743 19.6105 18.1063 19.5438L15.3594 16.9188C15.2832 16.8523 15.2212 16.7711 15.1772 16.6801C15.1332 16.589 15.1081 16.49 15.1033 16.389C15.0985 16.2881 15.1142 16.1871 15.1494 16.0924C15.1846 15.9976 15.2387 15.9109 15.3082 15.8375C15.3778 15.7642 15.4615 15.7056 15.5543 15.6654C15.647 15.6252 15.747 15.6042 15.8481 15.6036C15.9492 15.603 16.0494 15.6229 16.1426 15.662C16.2358 15.7011 16.3202 15.7587 16.3906 15.8312L18.6219 17.9594L23.6094 13.2062C23.7552 13.079 23.9446 13.0131 24.1379 13.0222C24.3312 13.0314 24.5135 13.1149 24.6467 13.2553C24.7798 13.3958 24.8535 13.5822 24.8524 13.7758C24.8513 13.9693 24.7754 14.1549 24.6406 14.2938Z",
				fill: "#0f172b"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_828_12962",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 4)"
			})
		}) })
	]
});
export default SvgRadioIcon;
